import bcrypt from 'bcryptjs';

/**
 * Verify a site code against its BCrypt hash.
 * The raw input is: siteCode + salt (concatenated, then verified against hash).
 * Must match backend's BCrypt.verifyer().verify() and Android CryptoUtils.verifyBcrypt().
 */
export function verifyBcrypt(raw: string, salt: string, hash: string): boolean {
  return bcrypt.compareSync(raw + salt, hash);
}
